import {
  PublicClientApplication,
  type Configuration,
  LogLevel,
} from '@azure/msal-browser'

const tenantId = import.meta.env.VITE_MSAL_TENANT_ID
const clientId = import.meta.env.VITE_MSAL_CLIENT_ID

const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    // Redirect URI must be registered in the Azure AD app registration.
    // DEV:  http://localhost:5173
    // PROD: https://<your-static-web-app>.azurestaticapps.net
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage', // sessionStorage is safer than localStorage for SPAs
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel:
        import.meta.env.VITE_ENV === 'development'
          ? LogLevel.Warning
          : LogLevel.Error,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        if (import.meta.env.VITE_ENV === 'development') {
          // eslint-disable-next-line no-console -- MSAL diagnostics, dev builds only.
          console.log(`[MSAL][${LogLevel[level]}] ${message}`)
        }
      },
    },
  },
}

// Scopes requested when acquiring an access token for the back-end API.
// The IR API app registration exposes the `access_as_user` delegated scope.
export const apiScopes = [import.meta.env.VITE_API_SCOPE]

// Scopes for sign-in (openid profile are added automatically by MSAL)
export const loginRequest = {
  scopes: apiScopes,
}

export const msalInstance = new PublicClientApplication(msalConfig)

/**
 * Removes MSAL's "interaction in progress" lock from session storage.
 * An interrupted redirect (AAD error page, closed tab) leaves the lock set,
 * which makes every subsequent loginRedirect() reject instead of navigating.
 */
export function clearStaleInteractionStatus() {
  for (const key of Object.keys(sessionStorage)) {
    if (key.startsWith('msal.') && key.endsWith('.interaction.status')) {
      sessionStorage.removeItem(key)
    }
  }
}
